var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "payment-summary fsize-13 color-grey4" },
    [
      _vm.order.Subtotal != _vm.order.Total
        ? _c("li", { staticClass: "flex-between-end" }, [
            _c("div", [_vm._v("Sous Total")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.prix(_vm.order.Subtotal)))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      +_vm.order.ProcessingFee
        ? _c("li", { staticClass: "flex-between-end" }, [
            _c("div", [_vm._v("Frais de gestion")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.prix(_vm.order.ProcessingFee)))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.order.ShippingFee
        ? _c("li", { staticClass: "flex-between-end" }, [
            _c("div", [_vm._v("Frais de livraison")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.prix(_vm.order.ShippingFee)))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      +_vm.order.Tip
        ? _c("li", { staticClass: "flex-between-end" }, [
            _c("div", [_vm._v("Pourboire")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.prix(_vm.order.Tip)))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      +_vm.order.Discount
        ? _c("li", { staticClass: "flex-between-end color-bo-p2" }, [
            !_vm.order.promo_code ? _c("div", [_vm._v("Remise")]) : _vm._e(),
            _vm._v(" "),
            _vm.order.promo_code
              ? _c("div", [_vm._v(_vm._s(_vm.order.DiscountName))])
              : _vm._e(),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.prix(_vm.order.Discount)))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.order.Remain != _vm.order.Total
        ? _c("li", { staticClass: "flex-between-end color-black mt-20" }, [
            _c("h4", [_vm._v("Déjà réglé")]),
            _vm._v(" "),
            _c(
              "h4",
              {
                staticStyle: { "text-align": "right", "white-space": "nowrap" },
              },
              [_vm._v(_vm._s(_vm.prix(-(_vm.order.Total - _vm.order.Remain))))]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("CollapseTransition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPayments,
                expression: "showPayments",
              },
            ],
          },
          _vm._l(_vm.order.payments, function (payment) {
            return _c(
              "li",
              {
                key: payment.id,
                staticClass: "flex-between-end color-grey4",
                style: {
                  textDecoration: _vm.isCaptured(payment)
                    ? "auto"
                    : "line-through",
                },
              },
              [
                _c("div", [_vm._v(_vm._s(_vm.paymentTitle(payment)))]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "right",
                      "white-space": "nowrap",
                    },
                  },
                  [_vm._v(_vm._s(_vm.prix(-payment.Amount)))]
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.order.Remain != _vm.order.Total
        ? _c(
            "li",
            {
              staticClass: "flex-between-end fsize-16 text-bold color-2 mt-20",
            },
            [
              _c("div", [_vm._v("Reste à payer")]),
              _vm._v(" "),
              _c("div", { staticStyle: { "text-align": "right" } }, [
                _vm._v(_vm._s(_vm.prix("" + _vm.order.Remain))),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }